function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
import styled from 'styled-components';
import sx from '../../sx';
import { Text } from '../..';
/**
 * The gradient text component crops an element’s background to match the shape of the text.
 * Useful for effects where you want a gradient background image to be visible through the text.
 * 
 * the default gradient stops to use for Appfire branding are:
 * 
 * ```jsx
// orange-yellow gradient values 
// gradient-to: #F96C2C
// gradient-from: #F9D95D
//
// green-blue gradient values 
// gradient-to: #1FDA96 
// gradient-from: #3FB3F2
//
// pink-orange gradient values 
// gradient-to: #E54074 
// gradient-from: #F96C2C
```
 * 
 * Product scale font-size values are based on a base-font size of `14px` which 
 * generates odd decimal values when calculating `rem` units. Product scale values are included as 
 * a reference. See "Theme Reference" in the docs for more information.
 *
 *```javascript
 
 "fontSizes": [
    "10px", 
    "11px", 
    "14px", // product scale base font-size
    "16px",
    "20px",
    "24px",
    "28px",
    "36px",
    "47px",
    "62px",
    "84px" 
  ],
 
 ```
 * 
 */
const GradientText = ({
  sx: sxProp,
  children,
  gradientTo = '#1FDA96',
  gradientFrom = '#3FB3F2',
  fallbackColor = '#0098eb',
  gradientDirection = 'right',
  size,
  as = 'p',
  ...props
}) => {
  return /*#__PURE__*/React.createElement(StyledText, _extends({
    as: as,
    sx: sxProp,
    style: {
      '--size': size + 'px'
    }
  }, props), /*#__PURE__*/React.createElement(Gradient, {
    style: {
      '--gradient-to': gradientTo,
      '--gradient-from': gradientFrom,
      '--gradient-direction': gradientDirection,
      '--fallback-color': fallbackColor
    }
  }, children));
};
GradientText.displayName = "GradientText";
const StyledText = styled(Text).withConfig({
  displayName: "GradientText__StyledText",
  componentId: "sc-2aww6i-0"
})(["font-size:var(--size);line-height:1;font-weight:800;letter-spacing:-0.025em;color:transparent;", ""], sx);
const Gradient = styled.span.withConfig({
  displayName: "GradientText__Gradient",
  componentId: "sc-2aww6i-1"
})(["background-color:var(--fallback-color);--gradient-stops:var(--gradient-from),var(--gradient-to,var(--fallback-color));-webkit-background-clip:text;-webkit-text-fill-color:transparent;-moz-background-clip:text;-moz-text-fill-color:transparent;background-clip:text;background-image:linear-gradient(to var(--gradient-direction),var(--gradient-stops));box-decoration-break:clone;-webkit-box-decoration-break:clone;"]);
export default GradientText;